import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/shared';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserRoles } from '@entity/user-role';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  loading: boolean;
  message = '';
  resetForm: FormGroup;
  roleId: number;
  icon: string;
  type: string;
  icon2: string;
  type2: string;
  icon3: string;
  type3: string;

  constructor(private auth: AuthService, private fb: FormBuilder, public router: Router) { }

  ngOnInit() {
    this.icon = 'fa-eye-slash';
    this.type = 'password';

    this.icon2 = 'fa-eye-slash';
    this.type2 = 'password';

    this.icon3 = 'fa-eye-slash';
    this.type3 = 'password';
    
    if (localStorage.getItem("resetFlag") != "true")
      this.router.navigate(["/login"]);;
    this.resetForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      firstname: '',
      lastName: '',
      address: '',
      userName: ''
    }, { validator: this.checkPasswords });
    this.getuserDetails();
  }

  iconChange() {
    if (this.icon == 'fa-eye-slash') {
      this.icon = 'fa-eye';
      this.type = 'text';
    } else {
      this.icon = 'fa-eye-slash'
      this.type = 'password';
    }
  }

  iconChange2() {
    if (this.icon2 == 'fa-eye-slash') {
      this.icon2 = 'fa-eye';
      this.type2 = 'text';
    } else {
      this.icon2 = 'fa-eye-slash'
      this.type2 = 'password';
    }
  }

  iconChange3() {
    if (this.icon3 == 'fa-eye-slash') {
      this.icon3 = 'fa-eye';
      this.type3 = 'text';
    } else {
      this.icon3 = 'fa-eye-slash'
      this.type3 = 'password';
    }
  }

  getuserDetails() {
    this.auth.getUser().subscribe((res:any) => {
      this.roleId = res.RoleId;
      this.resetForm.patchValue({
        firstname: res.Firstname,
        lastName: res.Lastname,
        address: res.Address,
        userName: res.LoginId
      });
      this.setPasswordPattern();
    });
  }

  checkPasswords(group: FormGroup) {
    let newPwd = group?.get('newPassword')?.value ? group?.get('newPassword')?.value.trim() : "";
    let confirmPwd = group?.get('confirmPassword')?.value ? group?.get('confirmPassword')?.value.trim() : "";

    let pass = confirmPwd ? confirmPwd.trim().toLowerCase().slice(0, 5) : '';
    let firstName = group?.get('firstname')?.value ? group?.get('firstname')?.value.trim().toLowerCase().slice(0, 5) : '';
    let lastName = group?.get('lastName')?.value ? group?.get('lastName')?.value.trim().toLowerCase().slice(0, 5) : '';
    let address = group?.get('address')?.value ? group?.get('address')?.value.trim().toLowerCase().slice(0, 5) : '';
    let userName = group?.get('userName')?.value ? group?.get('userName')?.value.trim().toLowerCase().slice(0, 5) : '';
    let pwd = group?.get('confirmPassword')?.value.trim().toLowerCase().slice(0, 4);// it contains llwr    
    return newPwd === confirmPwd ? pass && (pwd === "llwr" || pass === userName || pass === firstName || pass === lastName || pass === address) ? { notSameUserInfo: true } : null : { notSame: true };
  }

  onSubmit() {
    this.message = ''; this.loading = true;
    this.auth.resetPassword(this.resetForm.value).then(res => {
      if (!res) {
        this.loading = false; this.message = 'old password does not match';
      }
    });
  }

  pwdMoreThanTwiceValidator(control: FormGroup) {
    var text = control.value.split("");
    let valid = false;
    text.some(function (v, i, a) {
      let array = a.filter(x => x.trim().toLowerCase() == v.trim().toLowerCase());
      if (array != null && array.length > 2)
        valid = true;
    });
    return valid ? { moreThanTwice: true } : null;
  }

  setPasswordPattern() {
    let regex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!#$@%&_-])(?=.{' + this.minLength + ',}).+$';
    this.resetForm?.get('newPassword')?.setValidators([Validators.required, Validators.minLength(parseInt(this.minLength)), Validators.pattern(regex), this.pwdMoreThanTwiceValidator]);
    this.resetForm?.get('newPassword')?.updateValueAndValidity();
  }

  get minLength() {
    return (this.roleId === UserRoles.Admin) || (this.roleId === UserRoles.SuperAdmin) ? "12" : "10";
  }

  navigation() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}